import { sortByLabel } from '../../data_management/sorters/sort_by_label';

class SearchSelector {
  filterString = '';

  get filteredItemList() {
    if (this.filterString.isEmpty || !this.itemList || this.itemList.length === 0) {
      return this.itemList
        .sort(sortByLabel);
    } else {
      return this.itemList
        .filter(i => i.label.toUpperCase().indexOf(this.filterString.toUpperCase()) >= 0)
        .sort(sortByLabel);
    }
  }

  getCSSClass(item) {
    if (item === this.selectedItem) {
      return 'selected';
    } else {
      return 'unselected';
    }
  }

  selectItem(item) {
    this.selectedItem = item;
    this.itemSelected({selectedItem: this.selectedItem});
  }
}

export default {
  name: 'searchSelector',
  obj: {
    controller: SearchSelector,
    bindings: {
      itemList: '<',
      itemSelected: '&'
    },
    template: `
      <input placeholder="Search" ng-model="$ctrl.filterString">
      <ol>
        <li ng-repeat="i in $ctrl.filteredItemList" 
            ng-click="$ctrl.selectItem(i)"
            ng-class="$ctrl.getCSSClass(i)">{{i.label}}</li>
      </ol>
    `
  }
}